import { ReactComponent as CardViewIconSvg } from './card-view.svg'
export default CardViewIconSvg
